import {
  Tag,
  Flex,
  Box,
  Switch,
  Stack,
  Text,
  useColorMode,
  useColorStyle,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  TabPanel,
  Checkbox,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { storeSelector, usePolicyContext } from '@Policy/store';
import { ExchangeOnlinePolicyItem } from '@Policy/utils/types';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import { isInUIC } from '@Utils/common';
import { Info } from '@Components/Common/Info';
import SecurityRisksTab from './tabs/SecurityRisksTab';
import AnomaliesTab from './tabs/AnomaliesTab';
import CustomCorrelatedIntelligenceTab from './tabs/CustomCorrelatedIntelligenceTab';
import NotificationApprovedListTab from './tabs/NotificationApprovedListTab';
// import { useState } from 'react';
// import { TrendVisionOneModal } from 'src/pages/Administrator/EmailReporting/TrendVisionOneModal';

function RiskAiDetection() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  const contextStore = usePolicyContext();
  const contextSelector = storeSelector(contextStore);
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  // const [isTrendVisionOneModalOpen, setIsTrendVisionOneModalOpen] =
  //   useState(false);

  const showAgenticAICheckbox = !!(
    selectedOrgGlobalSetting?.rai_agenticai_enabled_checkbox &&
    (isInUIC() || import.meta.env.DEV)
  );

  const { raiEnabled, raiAgenticAiEnabled, setRiskAiState } = contextSelector(
    (s) => {
      const template = s.template as ExchangeOnlinePolicyItem;
      return {
        raiEnabled: template.tmRiskAiFilters.raiEnabled,
        raiAgenticAiEnabled: template.tmRiskAiFilters.raiAgenticAiEnabled,
        setRiskAiState: s.setRiskAiState,
      };
    }
  );

  return (
    <Stack gap="6x" mt="2x">
      <Stack gap="2x">
        <Flex alignItems="center">
          <Switch
            mr="1x"
            checked={!!raiEnabled}
            onChange={(e) =>
              setRiskAiState({ raiEnabled: e.target.checked ? 1 : 0 })
            }
          />
          <Text size="xl">{t('policy.filterName.riskAi')}</Text>
        </Flex>
        <Text color={colorStyle.color.secondary} whiteSpace="pre-line">
          {t('policy.riskAi.desc')}
        </Text>
        {/* {!isInUIC() && (
          <Alert variant="outline" severity="info">
            {t('policy.updateV1.desc')}{' '}
            <LinkButton onClick={() => setIsTrendVisionOneModalOpen(true)}>
              {t('policy.updateV1.viewDetails')}
            </LinkButton>
          </Alert>
        )} */}
        {showAgenticAICheckbox && (
          <Box mt="4x">
            <Checkbox
              checked={!!raiAgenticAiEnabled}
              onChange={(e) =>
                setRiskAiState({
                  raiAgenticAiEnabled: e.target.checked ? 1 : 0,
                })
              }
            >
              {t('riskAi.agenticAi.checkbox')}
              <Tag variant="outline" size="sm" ml="2x">
                {t('common.label.preview')}
              </Tag>
              <Info
                content={t('riskAi.agenticAi.info')}
                placement="bottom-start"
                ml="2x"
              />
            </Checkbox>
          </Box>
        )}
      </Stack>
      <Tabs>
        <TabList>
          <Tab>{t('riskAi.tab.threat')}</Tab>
          <Tab>{t('riskAi.tab.anomaly')}</Tab>
          <Tab>{t('riskAi.tab.customizedAnomaly')}</Tab>
          <Tab>{t('riskAi.tab.notificationApprovedList')}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <SecurityRisksTab />
          </TabPanel>
          <TabPanel>
            <AnomaliesTab />
          </TabPanel>
          <TabPanel>
            <CustomCorrelatedIntelligenceTab />
          </TabPanel>
          <TabPanel>
            <NotificationApprovedListTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
      {/* {isTrendVisionOneModalOpen && (
        <TrendVisionOneModal
          isOpen={isTrendVisionOneModalOpen}
          onClose={() => setIsTrendVisionOneModalOpen(false)}
        />
      )} */}
    </Stack>
  );
}

export default RiskAiDetection;
